import { createFileRoute } from "@tanstack/react-router";
import { MultilingualVisaLanding } from "@/components/MultilingualVisaLanding";
import { getVisaLocale, VISA_HREFLANG_ALTS } from "@/data/visa-i18n";
import { multiHreflangLinks, SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";
import { speakableSchema, howToSchema, serviceWithReviewsSchema } from "@/lib/aeo";
import { entitySameAsSchema, softwareApplicationSchema } from "@/lib/trust-schema";

const L = getVisaLocale("ja");

export const Route = createFileRoute("/ja/visa")({
  head: () => ({
    meta: [
      { title: ctaTitle(L.title, "/ja/visa", "th")},
      { name: "description", content: ctaDesc(L.description, "/ja/visa", "th")},
      { property: "og:title", content: ctaTitle(L.title, "/ja/visa", "th")},
      { property: "og:description", content: ctaDesc(L.description, "/ja/visa", "th")},
      { property: "og:url", content: `${SEO_SITE}${L.path}` },
      { property: "og:locale", content: L.ogLocale },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${L.path}` },
      ...multiHreflangLinks(VISA_HREFLANG_ALTS, "/visa"),
    ],
    scripts: [
      speakableSchema(),
      howToSchema({
        name: L.h1,
        description: L.quickAnswer.a,
        inLanguage: "ja",
        totalTime: "P7D",
        estimatedCost: { currency: "THB", value: "2500" },
        steps: L.steps.map((s) => ({ name: s.name, text: s.text })),
      }),
      serviceWithReviewsSchema({
        path: L.path,
        serviceType: "Thailand Visa Document Translation & MFA Legalization",
        name: L.title,
        description: L.description,
        priceFromThb: 2500,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "ja",
          mainEntity: L.faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      entitySameAsSchema(),
      softwareApplicationSchema({
        url: `${SEO_SITE}/api/public/mcp`,
        name: "NYC Language Institute — MCP Server",
        description: "AI agent endpoint exposing Thailand visa document translation tooling.",
      }),
    ],
  }),
  component: () => <MultilingualVisaLanding l={L} />,
});
